import { useState, useEffect } from 'react';
export var useContainerDimensions = function (containerRef, onResize) {
    var getDimensions = function () {
        var _a, _b;
        return ({
            width: ((_a = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _a === void 0 ? void 0 : _a.offsetWidth) || 0,
            height: ((_b = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0
        });
    };
    var _a = useState({
        width: 0,
        height: 0
    }), dimensions = _a[0], setDimensions = _a[1];
    var handleResize = function () {
        var value = getDimensions();
        setDimensions(value);
        if (onResize)
            onResize(value);
    };
    useEffect(function () {
        var container = containerRef === null || containerRef === void 0 ? void 0 : containerRef.current;
        if (container) {
            var resizeObserver_1 = new ResizeObserver(handleResize);
            resizeObserver_1.observe(container);
            return function () { return resizeObserver_1.disconnect(); };
        }
    }, [containerRef]);
    useEffect(function () {
        var dimensionsTimeout = setTimeout(function () {
            if (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current) {
                setDimensions(getDimensions());
            }
        }, 100);
        window.addEventListener('resize', handleResize);
        return function () {
            clearTimeout(dimensionsTimeout);
            window.removeEventListener('resize', handleResize);
        };
        // eslint-disable-next-line
    }, [containerRef]);
    return { dimensions: dimensions, handleResize: handleResize };
};
export var getSecureTableHeight = function (height, basicHeight) {
    if (basicHeight === void 0) { basicHeight = 300; }
    return (Number.isNaN(height) || height < 0 ? basicHeight : height);
};
export default useContainerDimensions;
